import NotificationCreateEditComponent from 'src/components/features/superAdmin/notificationCreateEditComponent';

const CreateEditNotificationPage = () => <NotificationCreateEditComponent />;

export default CreateEditNotificationPage;
